/**
 * Build the aria-describedby attribute for the checkbox
 * @param extraAriaDescribedBy
 * @param helpContent
 * @param checkBoxkHelpContentId
 * @param textError
 * @param hasError
 * @param checkBoxErrorId
 * @param screenReaderId
 * @returns {string}
 * @constructor
 */
export const buildAriaDescribedBy = ({ extraAriaDescribedBy, helpContent, checkBoxkHelpContentId, errorText, hasError, checkBoxErrorId, screenReaderText, screenReaderId, }) => {
    let res = extraAriaDescribedBy;
    if (screenReaderText) {
        res += ` ${screenReaderId}`;
    }
    if (helpContent) {
        res += ` ${checkBoxkHelpContentId}`;
    }
    if (hasError && errorText) {
        res += ` ${checkBoxErrorId}`;
    }
    return res ? res.trim() : undefined;
};
//# sourceMappingURL=aria.utils.js.map